export const presets = {
    threshold: 'debug',
    levels: [
        {
            fn: 'debug',
            label: '🗒',
            color: 'grey',
        },
        {
            fn: 'info',
            label: '💎️',
            color: '#6060BA',
        },
        {
            fn: 'warn',
            label: '',
            color: '#817123',
        },
        {
            fn: 'error',
            label: '',
            color: '#A16666',
        },
    ],
    filter() {
        return true;
    },
    prefixFn({ label, color }, location) {
        const loglevel = label ? `${ label } ` : '';
        const styles = color ? `color: ${ color }` : '';

        return [`${ styles ? '%c' : '' }${ loglevel }[${ location }]`, styles];
    },
    prefixLocation(vm) {
        let location = `unknown`;

        if (vm) {
            const tag = vm.$options._componentTag;
            location = `${ tag ? `${ tag } #${ vm._uid }` : `#${ vm._uid }` }`;
        }

        return location;
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/plugins/vue-log/presets.js